import type { SortingState } from '@tanstack/table-core';

import type { INewPatientRow } from '../../services/patientsService/types';
import type { IPastPatientRowV2 } from '../Patients/store';

export enum PatientsViews {
  All = 'All',
}

export interface IPatientsUuid {
  uuid: string;
  fullName: string;
}
export type HomepageFilterName =
  | 'fallRisk'
  | 'deteriorating'
  | 'progress'
  | 'rtm'
  | 'hep'
  | 'discharged'
  | 'clinician'
  | 'typeOfCare'
  | 'careLocation'
  | 'recentData'
  // One dynamic Filters-popover section per org-configured event-based attribute.
  | `eventAttribute:${string}`;

export type IHomepagePatient = IPastPatientRowV2 | INewPatientRow;

export type IAllPatientsTableSorting = Partial<Record<PatientsViews, SortingState>>;
